import { useCallback } from "react";
import { UrlForwardsApi, useAPIAction } from "melco-shared-logic";
import { EditForwardFormValueInterface } from "../../components/urlforward/form/EditForwardForm";

export const useEditForward = () => {
  const [editForward] = useAPIAction(
    UrlForwardsApi,
    async (api, ForwardLinkDetails: EditForwardFormValueInterface) => {
      const data = await api.urlForwardsEdit({
        id: ForwardLinkDetails.id ?? "",
        controlcenterMelcoControlCenterModelsForwardLinkRequest: {
          key: ForwardLinkDetails.key,
          target_url: ForwardLinkDetails.target,
        },
      });

      return {
        successMessages: [{ message: "default" }],
        data,
      };
    },
    {
      translationPrefix: "url_forward.actions.edit",
    }
  );

  return useCallback(
    async (forwardLinkDetails: EditForwardFormValueInterface) => {
      try {
        await editForward(forwardLinkDetails);
      } catch (e) {
        return { success: false };
      }

      return { success: true };
    },
    [editForward]
  );
};
